// extracted by mini-css-extract-plugin
export default {"tabs__header--active":"tabs__header--active--2jwt9","tabs__header":"tabs__header--pbNXS","tabs__headers--compact":"tabs__headers--compact--_uhdM","tabs":"tabs--cjrCJ","tabs__headers":"tabs__headers--25iln","tabs__header__icon":"tabs__header__icon--2z0F8","tabs__arrow":"tabs__arrow--1WOoE","tabs__header--disabled":"tabs__header--disabled--2GriF"};
    if(module.hot) {
      // 1747648163556
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  